'use client';

import React, { FC, JSX, PropsWithChildren } from 'react';
import { useProductPageContext } from '@/components/productPageContext/ProductPageContext';

const PrintModeWrapper: FC<PropsWithChildren> = ({ children }): JSX.Element => {
  const { printMode } = useProductPageContext();

  return !printMode ? <>{children}</> : <></>;
};

export default PrintModeWrapper;
